<template>
  <div class="profile">
    <div class="profile-info">
      <div class="avatar-wrapper">
        <img src="@/assets/pfp.jpg" alt="Profile Image" class="profile-image">
        <img src="@/assets/srking_crownborder.png" alt="Crown Border" class="crown-border">
      </div>
      <p class="profile-name">Sr. King</p>
    </div>
    <div class="social-icons-box">
      <div class="social-icons Frosted_glass">
        <a class="social-icon" href="#" @click.prevent="$emit('show-profile')" rel="noopener noreferrer"><i class="fas fa-user"></i></a>
        <a class="social-icon" href="https://shop.king.sv" target="_blank" rel="noopener noreferrer"><i class="fas fa-cart-shopping"></i></a>
        <a class="social-icon" href="https://discord.gg/kingsz" target="_blank" rel="noopener noreferrer"><i class="fab fa-discord"></i></a>
        <a class="social-icon" href="https://t.me/fodebi" target="_blank" rel="noopener noreferrer"><i class="fab fa-telegram"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileCard'
}
</script>

<style scoped>
.profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}

.avatar-wrapper {
  position: relative;
  width: 9.375rem;
  height: 9.375rem;
}

.profile-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.crown-border {
  position: absolute;
  top: -35%;
  left: -9.1%;
  width: 117.5%;
  height: 143.4%;
  pointer-events: none;
}

.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-name {
  font-size: 1.875rem;
  font-weight: bold;
}

.social-icons-box {
  padding: 0.85rem;
  border-radius: 1.875rem;
  backdrop-filter: blur(0.625rem) brightness(0.8);
  transition: transform 0.3s ease, filter 0.3s ease;
  margin-top: -1rem;
}

.social-icons {
  cursor: none;
  display: flex;
  justify-content: center;
}

.social-icons a {
  cursor: none !important;
  color: white;
  font-size: 1.5rem;
  margin: 0 0.625rem;
}

.social-icon {
  transition: transform 0.3s ease, filter 0.3s ease;
}

.social-icon:hover {
  transform: scale(1.1);
}

.social-icons-box:hover {
  transform: scale(1.01);
  backdrop-filter: blur(0.625rem) brightness(0.6);
}

.Frosted_glass {
  backdrop-filter: blur(0.625rem) brightness(0.7);
}
</style>
